window.addEventListener("error", (e) => {
  if (
    e.message.includes(
      "ResizeObserver loop completed with undelivered notifications"
    )
  ) {
    e.stopImmediatePropagation();
  }
});

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Antd from "ant-design-vue";

import dayjs from "dayjs";
import "dayjs/locale/zh";
dayjs.locale("zh");

import "./assets/jrosion.css";

/*
var utc = require("dayjs/plugin/utc");
var timezone = require("dayjs/plugin/timezone"); // dependent on utc plugin
dayjs.extend(utc);
dayjs.extend(timezone);
*/
// provide 设置全局参数， vue页面直接inject("myGlobalVariable")获取
createApp(App)
  .provide("company", "湖南百印电子商务有限公司")
  .provide("appname", "七妙客电商SaaS一体化平台5.0")
  .provide("version", "V5.0.0.202501.beta")
  .provide("serverAddress", "127.0.0.1:8787")
  .provide("serverIp", "127.0.0.1")
  .use(store)
  .use(Antd)
  .use(router)
  .mount("#app");
